module.exports = __webpack_public_path__ + "img/empty.82907bfe.png";